var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    buttons          = require("app/theme/buttons"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap"),
    quickMacroize    = require("enyo/macroize").quickMacroize;

require("app/theme/IconButton--header-dropdown-flag.less");

module.exports = kind(/** @lends  app.AppHeader.LanguageMenuButton.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.LanguageMenuButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-app-header-language-menu-button",

    /**
     * @private
     */
    mixins: [
        HyperLinkSupport
    ],

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: buttons["app.AppHeader.LanguageSwitcher.menuButton"],

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: null,

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.router.matchedPathname", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            language    = i18nService.get("language"),
            data        = this.data || {},
            urlPath     = this.app.$.router.matchedPathname;

        this.set("icon", icons[quickMacroize("app.AppHeader.LanguageSwitcher.LanguageIcon.{$language}", {
            language: data.language
        })]);
        this.set("caption", i18nService.getString(quickMacroize("app.AppHeader.LanguageSwitcher.Button.{$language}.caption", {
            language: data.language
        })));
        this.set("tooltip", i18nService.getString(quickMacroize("app.AppHeader.LanguageSwitcher.Button.{$language}.tooltip", {
            language: data.language
        })));
        this.set("href", urlPath ? i18nService.translateUrlPath(urlPath, data.language) : null);
        this.set("showing", language !== data.language);
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    tap: function() {
        var authService = this.app.$.authService,
            data        = this.data || {};

        // If the user is logged in we set the new language as preferred
        // language.
        if (authService.isLoggedIn === 1
            && get(authService, "user.language", null) !== data.language) {
            authService.setLanguagePreference(data.language);
        }

        this.bubbleUp("onRequestHideDropdown", {
            hideParents: true
        });

        return onHyperlinkTap.call(this, this);
    }

});
